import { v4 as uuidv4 } from 'uuid';

const config = {
  apiKey: process.env.GATSBY_FIREBASE_KEY,
  authDomain: process.env.GATSBY_FIREBASE_DOMAIN,
  databaseURL: process.env.GATSBY_FIREBASE_DATABASE,
  projectId: process.env.GATSBY_FIREBASE_PROJECT_ID,
  storageBucket: process.env.GATSBY_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.GATSBY_FIREBASE_SENDER_ID,
  appId: process.env.GATSBY_FIREBASE_APP_ID,
  measurementId: process.env.GATSBY_FIREBASE_MES_ID,
};

class Firebase {
  constructor(app) {
    if (!firebaseInstance) {
      app.initializeApp(config);
      app.analytics();

      this.auth = app.auth();
      this.db = app.firestore();
      this.functions = app.functions();
      this.storage = app.storage();
      this.analytics = app.analytics();
      this.perf = app.performance();
      this.cred = (email, password) =>
        app.auth.EmailAuthProvider.credential(email, password);

      this.googleProvider = new app.auth.GoogleAuthProvider();
      this.facebookProvider = new app.auth.FacebookAuthProvider();
      this.githubProvider = new app.auth.GithubAuthProvider();
    }
  }

  // ============================== //
  // +    AUTH SECTION START      + //
  // ============================== //

  createUser = (username, email, password) =>
    this.functions.httpsCallable('createNewAccount')({
      username,
      email,
      password,
    });

  doSignInWithEmailAndPassword = (email, password) =>
    this.auth.signInWithEmailAndPassword(email, password);

  doSignOut = () => this.auth.signOut();

  doSignInWithGoogle = () => this.auth.signInWithPopup(this.googleProvider);

  doSignInWithFacebook = () => this.auth.signInWithPopup(this.facebookProvider);

  doSignInWithGithub = () => this.auth.signInWithPopup(this.githubProvider);

  doSendVerificationEmail = () => this.auth.currentUser.sendEmailVerification();

  doSendPasswordResetEmail = (email) => this.auth.sendPasswordResetEmail(email);

  socialLogin = () => this.functions.httpsCallable('socialLogin')();

  // ============================== //
  // +      AUTH SECTION END      + //
  // ============================== //

  // ============================================ //
  // +     ACCOUNT MANAGEMENT SECTION START     + //
  // ============================================ //

  updateUserAccount = (values) =>
    this.functions.httpsCallable('updateUserAccount')(values);

  getUserProfile = ({ userID, onSnapshot }) =>
    this.db.collection('users').doc(userID).onSnapshot(onSnapshot);

  getLiveUsername = ({ username, onSnapshot }) =>
    this.db
      .collection('users')
      .limit(1)
      .where('username', '==', username)
      .onSnapshot(onSnapshot);

  getUsernameByUID = (uid) => this.db.collection('users').doc(uid).get();

  publicProfile = (username) =>
    this.functions.httpsCallable('getPublicProfile')({ username: username });

  uploadProfilePicture = (image) =>
    this.storage
      .ref()
      .child(
        `users/${this.auth.currentUser.uid}/profilePicture/${uuidv4()}.${
          image.name.split('.')[1]
        }`
      )
      .put(image);

  reauthWithCredential = (email, password) => this.cred(email, password);

  // ========================================== //
  // +    ACCOUNT MANAGEMENT SECTION END      + //
  // ========================================== //

  // ========================================== //
  // +    SERVER FUNCTIONS SECTION START      + //
  // ========================================== //

  verifyCaptchaToken = (token, type) =>
    this.functions.httpsCallable('verifyCaptchaToken')({
      token: token,
      type: type,
    });

  checkValidConnection = (name) =>
    this.functions.httpsCallable('checkValidConnection')({ name: name });

  // ====================================== //
  // +    SERVER FUNCTIONS SECTION END    + //
  // ====================================== //
}

let firebaseInstance;

function getFirebaseInstance(app) {
  if (!firebaseInstance && app) {
    firebaseInstance = new Firebase(app);
    return firebaseInstance;
  } else if (firebaseInstance) {
    return firebaseInstance;
  } else {
    return null;
  }
}

export default getFirebaseInstance;
